import {inject, injectable} from 'inversify';

import {i18n} from '@yourcoach/i18n';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {ProgramModel} from './Program.model';

@injectable()
export class ProgramFactory
  implements BaseDomainFactory<ProgramModel, ProgramModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: ProgramModel.Props): ProgramModel {
    return this.modelsRegistry.put(new ProgramModel(props));
  }

  createEmpty(): ProgramModel {
    const apiData = {_id: '', avatar: null, title: ''};
    const title = i18n.t('shared:program_not_found');
    const avatar = null;
    const id = '';
    const description = '';

    return new ProgramModel({
      apiData,
      avatar,
      description,
      editions: [],
      id,
      title,
    });
  }
}
